import React, { useEffect, useRef, useState } from "react";
import { RCCButton, RCCGrid, RCCIcon, RCCInput, RCCPopover, RCCRadio, RCCTextArea, RCCTooltip,RCCRefLovProps, RCCSelectOptionsCard } from "react-common-components";
import LovClassifications from "src/components/Lov/Classifications";
import LovProcess from "src/components/Lov/Process";
import LovSectors from "src/components/Lov/Sectors";
import LovPeriodTypes from "src/components/Lov/TypePeriods";
import LovUsers from "src/components/Lov/Users";
import { useTranslation } from "src/context/Translations/context";
import Modals from "src/pages/Config/PeriodTypes/modals";
import { IRefTypePeriodsModals } from "src/pages/Config/PeriodTypes/interface";
import { useWatch } from "react-hook-form";
import Select from "src/components/Select";
import LovTags from "src/components/Lov/Tags";
import Audit from "src/components/Audit";
import { ClosedPeriods, EvaluationForm, IIqtbc001, IndicatorLevel, IGeneralTab } from "../interface";
import { FieldWithPopOver, StrategicIcon } from "../styles";

const TabGeneralData: React.FC<IGeneralTab> = ({ 
	indicator,
	tags,
	register,
	control,
	errors,
	setValue,
	isDuplicate
}) => {
	const { translate} = useTranslation();
	const [data,setData] = useState<IIqtbc001>(indicator);
	const refModals = useRef<IRefTypePeriodsModals>(null);
	const lovRef = useRef<RCCRefLovProps>(null);

	const sharedInputs = useWatch({
		control,
		name: [
			"indicator.iqc001Descricao",
			"indicator.iqc001Nivel",
			"indicator.iqc001Iqb003Id",
			"indicator.iqc001Efa005Id",
			"indicator.iqc001Taa001Id",
			"indicator.iqc001Formaaval"
		]
	});

	useEffect(() => {
		setData(indicator);
	}, [indicator]);

	return(
		<RCCGrid container item 
			justifyContent="center">
			<RCCGrid container item 
				xs={12} 
				sm={10} 
				lg={8}
			>
				<RCCGrid
					container
					item
					justifyContent="flex-end"
				>
					<RCCGrid item>
						<Audit 
							data={indicator} 
							type="pop" 
							position="left"
						/> 
					</RCCGrid>
				</RCCGrid>
				<RCCGrid container item>		
					<RCCInput 
						name="indicator.iqc001Descricao"
						register={register}
						label={translate("Descrição")}
						defaultValue={isDuplicate ? `(${translate("CÓPIA")}) ${sharedInputs[0]||data.iqc001Descricao}` : sharedInputs[0]||data.iqc001Descricao}
						error={errors?.indicator?.iqc001Descricao}
						maxLength={600}
						required
					/>
				</RCCGrid>
				<RCCGrid container item>
					<RCCSelectOptionsCard 
						name="indicator.iqc001Nivel"
						control={control}
						defaultValue={sharedInputs[1]?.toString()||data.iqc001Nivel?.toString()||IndicatorLevel.STRATEGIC}
						options={[
							{
								value:IndicatorLevel.STRATEGIC,
								label:translate("Estratégico"),
								icon:<StrategicIcon />
							},
							{
								value:IndicatorLevel.TATIC,
								label:translate("Tático"),
								icon:<RCCIcon name="chessKnight"/>
							},
							{
								value:IndicatorLevel.OPERATIONAL,
								label:translate("Operacional"),
								icon:<RCCIcon name="tools"/>
							}
						]}
						label={translate("Nível")}
					/>
				</RCCGrid>
				<RCCGrid container item
					wrap="nowrap"
					alignItems="center"
					xs={12}
				>	
					<RCCGrid container item>	
						<LovPeriodTypes
							name="indicator.iqc001Iqb003Id"
							label={translate("Tipo de período")}
							control={control}
							error={errors?.indicator?.iqc001Iqb003Id}
							setValue={setValue}
							required
							defaultValue={sharedInputs[2]?.toString()||data.iqc001Iqb003Id?.toString()}
						/>
					</RCCGrid>
					<RCCTooltip
						text={translate("Novo tipo de período")}
						color="purple"
					>
						<RCCButton 
							color="purple" 
							icon={{name:"plus"} }
							type="button" 
							size="sm"
							styleInline="margin-bottom:-16px;"
							onClick={() => {refModals.current?.actionButtonAdd();}}/>
					</RCCTooltip>
					<Modals 
						ref={refModals} 
						onClose={(newId) => lovRef.current?.setValue(newId.toString())}
					/>
				</RCCGrid>
				<RCCGrid container item>	
					<LovUsers
						name="indicator.iqc001Efa005Id"
						label={translate("Responsável")}
						control={control}
						error={errors?.indicator?.iqc001Efa005Id}
						required
						defaultValue={sharedInputs[3]?.toString()||data.iqc001Efa005Id?.toString()}
					/>
				</RCCGrid>
				<RCCGrid container item>		
					<LovSectors
						name="indicator.iqc001Taa001Id"
						label={translate("Setor")}
						control={control}
						error={errors?.indicator?.iqc001Taa001Id}
						isClearable
						isCreatable
						defaultValue={sharedInputs[4]?.toString()||data.iqc001Taa001Id?.toString()}
					/>
				</RCCGrid>
				<RCCGrid container item>		
					<LovClassifications
						name="indicator.iqc001Taa002Id"
						label={translate("Classificação")}
						control={control}
						error={errors?.indicator?.iqc001Taa002Id}
						isCreatable
						isClearable
						defaultValue={data.iqc001Taa002Id?.toString()}
					/>
				</RCCGrid>
				<RCCGrid container item>		
					<RCCRadio
						name="indicator.iqc001Formaaval"
						register={register}
						label={translate("Forma de avaliação")}
						color ="purple"
						styleInline="@media (max-width: 480px){
							display: block;
						}"
						error={errors?.indicator?.iqc001Formaaval}
						options={[
							{value:EvaluationForm.TO_UP,label:translate("Melhor para cima")},
							{value:EvaluationForm.TO_DOWN,label:translate("Melhor para baixo")}
						]}
						defaultValue={sharedInputs[5]?.toString()||data.iqc001Formaaval?.toString()}
					/>
				</RCCGrid>
				<RCCGrid container item
					wrap="nowrap"
					alignItems="baseline"
				>	
					<RCCGrid container 
						styleInline={FieldWithPopOver}
					>	
						<Select
							name="indicator.iqc001Periodofechado"
							label={translate("Períodos para cálculo")}
							control={control}
							error={errors?.indicator?.iqc001Periodofechado}
							options={[
								{value:ClosedPeriods.CLOSED_ONLY, label:translate("Somente períodos fechados")},
								{value:ClosedPeriods.CLOSED_AND_STARTED, label:translate("Períodos fechados ou iniciados")},
								{value:ClosedPeriods.ALL_PERIODS, label:translate("Todos períodos do ano base")}
							]}
							defaultValue={data.iqc001Periodofechado||ClosedPeriods.CLOSED_ONLY}
						/>
					</RCCGrid>
					<RCCPopover
						header={{title:translate("Períodos para cálculo")}}
						body={{text:translate("Indica como o indicador irá calcular o valor acumulado. Se só irá considerar os períodos que estejam encerrados, todos os períodos até a data atual ou todos os períodos do ano base")}}
					>
						<RCCIcon
							name="infoCircle"
						/>
					</RCCPopover>
				</RCCGrid>
				<RCCGrid container item>	
					<LovProcess
						name="indicator.iqc001Taa005Id"
						label={translate("Processo")}
						control={control}
						error={errors?.indicator?.iqc001Taa005Id}
						isCreatable
						isClearable
						defaultValue={data.iqc001Taa005Id?.toString()}
					/>
				</RCCGrid>
				<RCCGrid container item>	
					<LovTags 
						control={control}
						name="tags"
						isClearable
						label={translate("Tags")}
						defaultValue={Array.isArray(tags) ? tags.join(", ") : tags}
						extraParametersOnLoad={{
							use: 2
						}}
						extraParametersOnCreate={{
							use: 2
						}}
					/>
				</RCCGrid>
				<RCCGrid container item>	
					<RCCTextArea
						name="indicator.iqc001Fontedados"
						register={register}
						label={translate("Fonte de dados")}
						error={errors?.indicator?.iqc001Fontedados}
						maxLength={4000}
						defaultValue={data.iqc001Fontedados}
					/>
				</RCCGrid>
				<RCCGrid container item>	
					<RCCTextArea
						name="indicator.iqc001Metodo"
						register={register}
						label={translate("Método de avaliação")}
						error={errors?.indicator?.iqc001Metodo}
						maxLength={400}
						defaultValue={data.iqc001Metodo}
					/>
				</RCCGrid>
				<RCCGrid container item>	
					<RCCTextArea
						name="indicator.iqc001Descobjetivo"
						register={register}
						label={translate("Objetivos")}
						error={errors?.indicator?.iqc001Descobjetivo}
						maxLength={200}
						defaultValue={data.iqc001Descobjetivo}
					/>
				</RCCGrid>
				<RCCGrid container item>	
					<RCCTextArea
						name="indicator.iqc001Observacao"
						register={register}
						label={translate("Observação")}
						error={errors?.indicator?.iqc001Observacao}
						maxLength={4000}
						defaultValue={data.iqc001Observacao}
					/>
				</RCCGrid>
			</RCCGrid>
		</RCCGrid>
	);
};
export default TabGeneralData;
